import type { ReactNode } from "react";
import { cn } from "./cn";

export interface CardProps {
  title?: string;
  className?: string;
  children: ReactNode;
}

/** A genuinely independent group of content. Never nest a Card inside a Card. */
export function Card({ title, className, children }: CardProps) {
  return (
    <div className={cn("ui-card", className)}>
      {title ? <h3 className="ui-card-title">{title}</h3> : null}
      {children}
    </div>
  );
}
